import DataFieldCache from "@/models/data.field.cache";
import {isParentFieldType, isRootParentFieldType} from "@/auxillary/datafield.cache.helpers";

export interface IDataFieldDeletionReport {
    dataFieldCache: DataFieldCache,
    fieldValueWillBeDeleted: boolean,
    fieldDeletionWillBeUndone: boolean,
    hasChildFieldsWithValues: boolean
    deletedChildFields: Array<IDataFieldDeletionReport> | null
}

export const fieldsWithValuesWillBeDeleted = function (dataFields: Array<DataFieldCache>, parentIsNotVisible: boolean = false): Array<IDataFieldDeletionReport> {
    let fieldsWithDeletedValues: Array<IDataFieldDeletionReport> = [];
    for (const dataField of dataFields) {
        const fieldNotVisible = parentIsNotVisible || !dataField.isVisible;
        const fieldWasNotVisible = !dataField.wasVisible;
        // to catch new populations on fields that are not visible and never were visible (were always empty)
        if (fieldNotVisible && fieldWasNotVisible)
            continue;

        const isParentType = isParentFieldType(dataField.definitionType);
        const fieldHasValueOrIsParent = (dataField.currentValues?.value != {} &&
            dataField.currentValues?.value != undefined) || isParentType;
        const fieldWillBeDeleted = fieldNotVisible && fieldHasValueOrIsParent;
        const isNotProcessedField = dataField.currentValues?.value != undefined && dataField.currentValues?.value == "unprocessed";
        if (isNotProcessedField) {
            continue
        }

        let childFieldsWillBeDeleted = false;
        let dataFieldChildrenDeleted: Array<IDataFieldDeletionReport> | null = null;

        // check and add children of field
        if (isParentType && dataField.childFields.length > 0) {
            dataFieldChildrenDeleted = fieldsWithValuesWillBeDeleted(dataField.childFields, fieldNotVisible);
            childFieldsWillBeDeleted = dataFieldChildrenDeleted != null && dataFieldChildrenDeleted?.length > 0;
        }

        if ((fieldWillBeDeleted && !isRootParentFieldType(dataField.definitionType)) || childFieldsWillBeDeleted) {
            fieldsWithDeletedValues.push({
                dataFieldCache: dataField,
                fieldValueWillBeDeleted: fieldWillBeDeleted && !isRootParentFieldType(dataField.definitionType),
                fieldDeletionWillBeUndone: false,
                hasChildFieldsWithValues: childFieldsWillBeDeleted,
                deletedChildFields: dataFieldChildrenDeleted
            });
        }
    }

    return fieldsWithDeletedValues;
}

export const findFieldsWithDeletionUndone = function (dataFields: Array<DataFieldCache>, addChildren: boolean = false):
    Array<IDataFieldDeletionReport> {
    let fieldsWithDeletedValues: Array<IDataFieldDeletionReport> = [];
    for (const dataField of dataFields) {
        const isParentType = isParentFieldType(dataField.definitionType);
        let dataFieldChildrenDeleted: Array<IDataFieldDeletionReport> = [];

        // check and add removingChildren of field
        if (dataField.removingChildren.length > 0) {
            dataFieldChildrenDeleted.push(...findFieldsWithDeletionUndone(dataField.removingChildren, true));
        }

        // check and add children of field
        if (isParentType && dataField.childFields.length > 0) {
            dataFieldChildrenDeleted.push(...findFieldsWithDeletionUndone(dataField.childFields, addChildren));
        }

        if (addChildren || dataField.removingChildren.length > 0) {
            fieldsWithDeletedValues.push({
                dataFieldCache: dataField,
                fieldValueWillBeDeleted: !isParentType && addChildren,
                fieldDeletionWillBeUndone: addChildren,
                hasChildFieldsWithValues: dataFieldChildrenDeleted.length > 0,
                deletedChildFields: dataFieldChildrenDeleted.length > 0 ? dataFieldChildrenDeleted : []
            });
        }
    }

    return fieldsWithDeletedValues;
}
